import Icon from '../components/Icon.vue'

Icon.register({"arrow-alt-circle-right":{"width":512,"height":512,"paths":[{"d":"M256 8C393 8 504 119 504 256S393 504 256 504 8 393 8 256 119 8 256 8zM140 300H256V370.9C256 381.6 269 387 276.5 379.4L390.8 264.5C395.5 259.8 395.5 252.3 390.8 247.6L276.5 132.6C268.9 125 256 130.4 256 141.1V212H140C133.4 212 128 217.4 128 224V288C128 294.6 133.4 300 140 300z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/arrow-alt-circle-right.js
// module id = YN1m
// module chunks = 0